import { Theme, Tooltip, useMediaQuery } from "@mui/material";
import * as React from "react";
import {
  Datagrid,
  DateField,
  DeleteButton,
  FunctionField,
  List,
  ListProps,
  SimpleList,
  TextField,
  useListContext,
} from "react-admin";
import { CustomEmpty } from "../../forms/StyledEmpty";
import styles from "../../styles/style.module.scss";
import { UploadDocumentsConstants as UDC } from "../../utils/const";
import { Actions } from "./actions/Actions";
import Instructions from "./Instructions";

const IndexField: React.FC<any> = (props) => {
  const { data } = useListContext();

  // Найти индекс текущей записи
  const index = data.indexOf(props.record) + 1;

  return <span>{index}</span>;
};

export const UploadPhotosList: React.FC<ListProps> = (props: any) => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <>
      <List
        empty={<CustomEmpty />}
        {...props}
        title={UDC.title}
        actions={<Actions />}
        hasCreate
        hasList
      >
        {isSmall ? (
          <SimpleList
            hasBulkActions={false}
            primaryText={(record) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Tooltip title={record.fileName}>
                  <a href={record.link} target="_blank"><span className={styles.text}>{record.fileName}</span></a>
                </Tooltip>
                <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                  <span>{new Date(record.createdAt).toLocaleDateString()}</span>
                  <DeleteButton
                    label="Удалить"
                    style={{ textTransform: "capitalize" }}
                  />
                </div>
              </div>
            )}
          />
        ) : (
          <Datagrid bulkActionButtons={false}>
            <FunctionField
              label="Номер"
              render={(record: any) => <IndexField record={record} />}
            />
            <TextField
              source="fileName"
              label="Название"
              className={styles.text}
            />
            <TextField source="link" label="Ссылка" className={styles.text} />
            <DateField source="createdAt" label="Дата" />
            <DeleteButton
              label="Удалить"
              style={{ textTransform: "capitalize" }}
            />
          </Datagrid>
        )}
      </List>
      <Instructions />
    </>
  );
};
